import { get, post } from './http'

const circlePath = 'circle/frontend/'
const CIRCLE = {
  // 获取首页explore帖子列表
  getExploreList: (params) => {
    return get(`${circlePath}thread/homeList`, params)
  },
  // 获取圈子分类tab
  getCircleCategory: (params) => {
    return get(`${circlePath}circle/category/list`, params)
  },
  // 获取圈子tab列表
  getCircleCategoryList: (params) => {
    return get(`${circlePath}thread/category`, params)
  },
  // 获取我加入的圈子帖子列表
  getMyCircles: (params) => {
    return get(`${circlePath}circle/myCircles`, params)
  },
  // 变更我的圈子展示排序
  updateCircleOrder: (params) => {
    params.needAuth = true
    return post(`${circlePath}circle/update/myCircles/order`, params)
  },
  getMyCircleList: (params) => {
    return get(`${circlePath}thread/myCircleList`, params)
  },
  // 获取我加入的圈子帖子列表（最新）
  getMyCircleListRecent: (params) => {
    return get(`${circlePath}thread/myCircleList/recent`, params)
  },
  // 获取ip所属国家圈子帖子列表
  getLocalCircle: (params) => {
    return get(`${circlePath}thread/countryCircle/list`, params)
  },
  // 获取圈子推荐帖子
  getRelatedList: (params) => {
    return get(`${circlePath}thread/related`, params)
  },
  // 帖子置顶
  stick: (params) => {
    params.needAuth = true
    return post(`${circlePath}thread/top`, params)
  },
  // 取消帖子置顶
  cancelStick: (params) => {
    params.needAuth = true
    return post(`${circlePath}thread/cancelTop`, params)
  },
  // 获取圈子详情
  getCircleInfo: (params) => {
    return get(`${circlePath}circle/get`, params)
  },
  // 获取圈子列表
  getCircleList: (params) => {
    return get(`${circlePath}thread/list`, params)
  },
  // 获取入圈申请列表
  getApplyingList: (params) => {
    params.needAuth = true
    return get(`${circlePath}user/applyingList`, params)
  },
  // 加入圈子
  joinCircle: (params) => {
    params.needAuth = true
    return post(`${circlePath}user/joinCircle`, params)
  },
  // 检查是否可以修改圈子
  checkUpdatePermission: (params) => {
    return get(`${circlePath}circle/check/updateNum`, params)
  },
  // 修改圈子
  updateCircle: (params) => {
    params.needAuth = true
    return post(`${circlePath}circle/update`, params)
  },
  // 获取成员列表
  getMemberList: (params) => {
    return get(`${circlePath}user/list`, params)
  },
  // 添加助理权限
  setAssistant: (params) => {
    params.needAuth = true
    return post(`${circlePath}user/addCircleAdmin`, params)
  },
  // 移除助理权限
  removeAssistant: (params) => {
    params.needAuth = true
    return post(`${circlePath}user/cancelCircleAdmin`, params)
  },
  // 移除圈子成员
  removeMember: (params) => {
    params.needAuth = true
    return post(`${circlePath}user/removeCircle`, params)
  },
  // 允许加入圈子
  handelApply: (params) => {
    params.needAuth = true
    return post(`${circlePath}user/apply/verify`, params)
  },
  // 查看是否还有圈子创建中
  checkCircleCreated: (params) => {
    return get(`${circlePath}circle/check/createNum`, params)
  },
  // 查看圈子是否已经存在
  checkCircleName: (params) => {
    return post(`${circlePath}circle/check/name`, params)
  },
  // 创建圈子
  createCircle: (params) => {
    params.needAuth = true
    return post(`${circlePath}circle/create`, params)
  },
  // 所有圈子
  getAllCircles: (params) => {
    return get(`${circlePath}circle/list`, params)
  },
  // 搜索圈子
  getSearchCircle: (params) => {
    return get(`${circlePath}circle/page`, params)
  },
  // 退出圈子
  quitCircle: (params) => {
    params.needAuth = true
    return post(`${circlePath}user/quitCircle`, params)
  },
  // 获取新人推荐圈子
  getRecommendCircle: (params) => {
    return get(`${circlePath}recommend/list`, params)
  },
  // 跳过推荐圈子
  skipRecommendCircle: (params) => {
    return get(`${circlePath}recommend/skip`, params)
  },
  // 批量加入圈子
  batchJoinCircle: (params) => {
    return post(`${circlePath}user/batch/joinCircle`, params)
  },
  // 获取所有圈子
  getAllCircle: () => {
    return get(`${circlePath}circle/all`, )
  },
  // 获取指定圈子的tab
  getCircleTab: (params) => {
    return get(`${circlePath}circle/circleTab`, params)
  },
}

export default CIRCLE